import React from 'react';
import Chart from 'react-google-charts';
import PropTypes from 'prop-types';
import { NUMERIC_VALUE, GRAPH_COLOR_CODE } from '../../../../utils';

function AudienceGenderChart(props) {
  const { graphData: { male, female } } = props;
  const genderCount = NUMERIC_VALUE.HUNDRED - (male + female);
  const pieData = [['', ''], ['', male], ['', female], ['', genderCount]];
  const pieOptions = {
    title: '',
    pieHole: 0.6,
    tooltip: { trigger: 'none' },
    slices: [
      {
        color: GRAPH_COLOR_CODE.GREEN,
      },
      {
        color: GRAPH_COLOR_CODE.LIGHT_GREEN,
      },
      {
        color: GRAPH_COLOR_CODE.GRAY,
      },
    ],
    legend: {
      position: 'none',
      alignment: 'center',
      textStyle: {
        color: '233238',
        fontSize: 14,
      },
    },
    chartArea: {
      left: 0,
      top: 0,
      width: '100%',
      height: '80%',
    },
    fontName: 'Roboto',
  };
  return (
    <div className="App audienceGenderbBox">
      <Chart
        chartType="PieChart"
        data={pieData}
        options={pieOptions}
        graph_id="PieChart"
        width="94px"
        height="94px"
        className="audienceGenderChart"
        legend_toggle
      />
      <div className="pieChartCount">
        <span>
          {female}
          %
          <em>Female</em>
        </span>
        <span>
          {male}
          %
          <em>Male</em>
        </span>
      </div>
    </div>
  );
}

AudienceGenderChart.propTypes = {
  graphData: PropTypes.object.isRequired,
};

export default AudienceGenderChart;
